import { format as formatDate } from 'date-fns';
import { API } from '@xbto/api-client';

export function formatStatementPeriodName(statement: API.AccountStatement) {
  return formatDate(new Date(statement.startDate), 'MMMM yyyy');
}
